import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostJiraCredentialsRequest = {
	apiToken: string;
	customerId: number;
	url: string;
	username: string;
};

export const postJiraCredentials = createPostEndpoint<PostJiraCredentialsRequest>('/api/v3/jira');
